
















import { EventFlowLocation } from '@/model/event-flow/EventFlow';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class LocationHeader extends Vue {
    @Prop() readonly eventFlowLocation!: EventFlowLocation;
    @Prop() readonly index!: number;
    @Prop() readonly isLast!: boolean;
}
